import React from 'react';

import { IFormFieldInputBaseProps } from '@components/form-fields';
import { MAIN_THEME } from '@styles';

import EnhancedButton from '../button/EnhancedButton';
import { IEnhancedMenuItem } from '../table/types';
import EnhancedMenu from './EnhancedMenu';

import { makeStyles } from 'tss-react/mui';

type ActionBarItems = Omit<IEnhancedMenuItem, 'onClick'> & {
  onClick: () => void;
};

export interface IActionBarProps extends IFormFieldInputBaseProps {
  items?: ActionBarItems[];
  title?: string;
  disabled?: boolean;
  dropdownActionsNames?: string[];
}

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    position: 'relative'
  },
  menuButton: {
    position: 'relative',
    borderRadius: 3,
    minHeight: 32,
    minWidth: 80,
    border: `1px ${MAIN_THEME.color.white86} solid`,
    boxSizing: 'border-box',
    padding: '0 15px',
    backgroundColor: MAIN_THEME.color.white,
    fontFamily: MAIN_THEME.font.regular,
    textTransform: 'capitalize',
    color: MAIN_THEME.color.black,
    fontSize: MAIN_THEME.fontSize.sm,
    lineHeight: '15px',
    textAlign: 'center',
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.4,
      pointerEvents: 'all',
      color: MAIN_THEME.color.black
    }
  }
}));

const SimpleActionBar: React.FC<IActionBarProps> = ({
  title = 'Actions',
  items = [],
  dropdownActionsNames = []
}) => {
  const actionClasses = useStyles().classes;

  const dropdownItems = dropdownActionsNames.length
    ? items.filter((item) => dropdownActionsNames.includes(item.name))
    : [];
  const buttonItems = dropdownActionsNames.length
    ? items.filter((item) => !dropdownActionsNames.includes(item.name))
    : items;

  return (
    <section title={title} className={actionClasses.container}>
      {buttonItems.map((item) => (
        <EnhancedButton
          key={item.name}
          disabled={item.disabled}
          onClick={item.onClick}
          isPrimary={item.isPrimary}
          state={item.state}
        >
          {item.title}
        </EnhancedButton>
      ))}
      {dropdownItems.length > 0 && (
        <EnhancedMenu
          title="Actions"
          items={dropdownItems}
          itemClassName={actionClasses.menuButton}
        />
      )}
    </section>
  );
};

export default SimpleActionBar;
